"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ajax_util_1 = require("../ajax/ajax.util");
var constants_1 = require("../../constants");
var REQUEST_URI = constants_1.default;
var page = require("page");
var timer = null, extendSessionTimer = null, expirationTime = 15 * 60 * 1000, confirmationTime = 14 * 60 * 1000, loginRedirectPath = "/signin";
/**
 * @function initTimer - clears any existing timers and restarts them. If timers expire, redirect to /extend-session,
 * then login if user doesn't complete actions that extend their session
 */
function initTimer(currentPath) {
    clearTimeout(timer);
    clearTimeout(extendSessionTimer);
    timer = setTimeout(function () {
        location = loginRedirectPath; // eslint-disable-line
    }, expirationTime);
    extendSessionTimer = setTimeout(function () {
        page("/extend-session?path=" + currentPath);
    }, confirmationTime);
}
/**
 * @function extendServerSession - Makes head call to server and resets session timers on success
 */
function extendServerSession(currentPath) {
    ajax_util_1.default.head$("/").then(function () { return initTimer(currentPath); });
}
/**
 * @function extendSession - throttle how often we extend session to prevent unnecessary traffic to the server
 */
function extendSession(enterView, currentPath) {
    // don't attempt to extend the session from the error route, so it doesn't inadvertently create more errors
    // empty enterRoute just means new agreement loaded
    if (!enterView || (enterView && !enterView.includes("Error"))) {
        currentPath =
            currentPath ||
                window.location.pathname.slice((REQUEST_URI + "/").length);
        extendServerSession(currentPath);
    }
}
exports.default = extendSession;
